import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getAuroScholarPaged, getTotalAuroSubscribers, removethisItem, processReminderMail } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR } from '../../../constant';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter } from 'reactstrap';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class AuroScholars   extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      openpopup:false,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export'
    }

    this.getTotal = this.getTotal.bind(this);
    this.getList = this.getList.bind(this);
    this.sendCustomMailAuro = this.sendCustomMailAuro.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);

  }


    getTotal = () => {


      getTotalAuroSubscribers().then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {
            
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }  

  componentDidMount() {

        var THIS = this;
        $(document).on('click', '.dlte', function () {
        var delete_id = $(this).data("id");
        
        if(confirm("You are sure to delete?")==true){

          let ins = JSON.stringify({
            id: delete_id,
            table:'auroscholars'
          });

          removethisItem(ins).then((res) => {

            if(res.status==1){
              NotificationManager.success('Removed successfully');
            }else{
              NotificationManager.error('Issue in removing');
            }
            this.getTotal('leads');
            this.getList();

          });

      }


      });
      
      this.getTotal();
      this.getList();

  }


      getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        perpage:this.state.PER_PAGE,
        year: this.state.year,
        month: this.state.month,
        offset:newOffset
      });

      getAuroScholarPaged(ins).then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          

            const aset = res.list.map((as) => ({
                "id": as.id,
                "email": as.email_id,
                "name" : as.name,
                "studentId": as.student_id,
                "auro_status":as.auro_status,
                "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(as.created_date)
            }));

            this.setState({ list: aset});


        } else {

              this.setState({loading:!this.state.loading});
              
              this.setState({
                list: [],
              });
        }
      });


    }  



    sendCustomMailAuro(){

         this.setState({openpopup:true});
    }
 

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }   

            
    handleEditorChange(value, editor) {
      this.setState({
        mail_content: value
      });
    }


    confirmSend = () =>{

      let ins = JSON.stringify({
        subject:this.state.subject,
        mail_content: this.state.mail_content
      });

      processReminderMail(ins).then((res) => {



      });

    }
   
 
  render() {
        const { list } = this.state;
        const { currentPage, PER_PAGE, totalCount, total, exportbtndisabled } = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                  <div class="col-12 grid-margin">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title">List</h4>
                        <button class="btn btn-main" onClick={this.sendCustomMailAuro}>Send Reminder Mail</button>                  
                        <div class="table-responsive pt-3">
                          <table class="table table-bordered table-sm">
                            <thead  class="thead-dark">
                              <tr>
                              
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Student Id</th>
                                <th>Auro Signup</th>
                                <th>Date</th>                         
                              </tr>
                            </thead>
                            <tbody>
                            {list.length>0 && list.map((asitem, i) => {     
                            
                            return <tr>
                                <td>
                                  {i+1}
                                </td>
                                
                                <td>{asitem.name}</td>
                                
                                <td>{asitem.email}</td>
                              
                                <td>{asitem.studentId}</td>

                                <td className={asitem.auro_status=='success'?"success":"failure"} >{asitem.auro_status}</td>

                                <td>{asitem.createdAt}</td>
                              
                              </tr>

                            })

                            }

                            {list.length==0 && 
                                <tr><td colSpan="6">No data</td></tr>
                            }
                            
                            </tbody>
                          </table>


                          <div class="text-center">
                            
                          <Pagination
                              activePage={this.state.activePage}
                              itemsCountPerPage={PER_PAGE}
                              totalItemsCount={this.state.total}
                              pageRangeDisplayed={5}
                              activeClass={"pagination__link--active"}
                              onChange={this.handlePageChange.bind(this)}
                              prevPageText="previous"
                              nextPageText="next"
                            />

                          </div>

                        </div>
                          
      
                      </div>
                    </div>
                  </div>  
                  <NotificationContainer/>

                  <Modal isOpen={this.state.openpopup} size="lg" className="modal-lg-60">

                      <ModalHeader>Custom Mail</ModalHeader>

                      <ModalBody>

                      <div class="label_item">Subject: <input type="text" name="subject" class="form-control" onChange={this.handleChange} /></div>   
                      <div class="label_item">To:  All subscribed users</div>   
                      <div class="label_item">Message:</div>   
                      <div class="partnerlist">
                        <Editor
                            onEditorChange={this.handleEditorChange}
                            toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                            }}
                            value={this.state.mail_content}
                            name="mail_content"
                            apiKey={TINY_EDITOR}
                            init={{
                                  height: 300,
                                  theme:"silver",
                                  plugins: ["advlist autolink lists link anchor paste image"],
                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                                
                            }}
                          />
                      </div>       

                      <div id="submittosend" class="row">
                        <div class="col-md-12">
                          <button class='btn btn-primary btn-sm' onClick={()=>this.confirmSend()}>Send</button>
                        </div>
                      </div>


                      </ModalBody>

                      <ModalFooter>
                            
                      </ModalFooter>      
                  </Modal>

                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default AuroScholars;


// WEBPACK FOOTER //
// ./src/components/bewise/exclsignups/auroscholars.jsx